import React, {useState, useContext, useEffect} from 'react';
import "../map/CrimeMap.css";
import { makeStyles } from '@material-ui/core/styles';
import FilterPanel from './FilterPanel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FilterContext from '../FilterContext';
import axios from "axios";
import {Container} from "@material-ui/core";
import packageJson from '../../package.json';

const useStyles = makeStyles((theme) => ({
    container: {
        textAlign: 'left',
        padding: '0.5rem 1rem',
    },
    formControl: {
        width: '100%'
    },
    formRow: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr'
    }
}));

function CrimeFilters(props) {
    const [context, setContext] = useContext(FilterContext);
    const classes = useStyles();

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    const [crimeTypes, setCrimeTypes] = useState([]);
    const [selectedCrimes, setSelectedCrimes] = useState([]);
    const [allSelected, setAllSelected] = useState(false);
    const [callTypes, setCallTypes] = useState([]);
    const [selectedCallTypes, setSelectedCallTypes] = useState([]);
    const [allCallTypesSelected, setAllCallTypesSelected] = useState(false);
    const [checkboxes, setCheckboxes] = useState({
        attempted: true,
        completed: true,
        hasArrestee: true,
        noArrestee: true,
        juvenile: true,
        adult: true,
        showIncidents : true,
        showCallsForService : false
    });

    const handleCrimeChange = (event) => {
        let newValue;
        if (event.target.value.indexOf("all") > -1) {
            if (allSelected) {
                setAllSelected(false);
                event.target.value.splice(event.target.value.indexOf("all"), 1)
                setSelectedCrimes(event.target.value);
                newValue = event.target.value;
            } else {
                setAllSelected(true);
                setSelectedCrimes(crimeTypes);
                newValue = crimeTypes;
            }
        } else {
            if (allSelected) {
                setAllSelected(false);
                setSelectedCrimes([]);
                newValue = [];
            } else {
                setSelectedCrimes(event.target.value);
                newValue = event.target.value;
            }
        }
        setContext({...context, filters: {...context.filters, crimeType: newValue}})
    };

    const handleCallTypeChange = (event) => {
        let newValue;
        if (event.target.value.indexOf("all") > -1) {
            if (allCallTypesSelected) {
                setAllCallTypesSelected(false);
                event.target.value.splice(event.target.value.indexOf("all"), 1)
                setSelectedCallTypes(event.target.value);
                newValue = event.target.value;
            } else {
                setAllCallTypesSelected(true);
                setSelectedCallTypes(callTypes);
                newValue = callTypes;
            }
        } else {
            if (allCallTypesSelected) {
                setAllCallTypesSelected(false);
                setSelectedCallTypes([]);
                newValue = [];
            } else {
                setSelectedCallTypes(event.target.value);
                newValue = event.target.value;
            }
        }
        setContext({...context, filters: {...context.filters, callTypes: newValue}})
    };

    const handleCheckboxChange = (event) => {
        setCheckboxes({...checkboxes, [event.target.name]: event.target.checked });
        switch (event.target.name) {
            case "attempted":
                if (event.target.checked) {
                    setCheckboxFilter("acFlag", "Attempted");
                } else {
                    setCheckboxFilter("acFlag", "Completed");
                }
                break;
            case "completed":
                if (event.target.checked) {
                    setCheckboxFilter("acFlag", "Completed");
                } else {
                    setCheckboxFilter("acFlag", "Attempted");
                }
                break;
            case "hasArrestee":
                if (event.target.checked) {
                    setCheckboxFilter("hasArrestee", "Y");
                } else {
                    setCheckboxFilter("hasArrestee", "N");
                }
                break;
            case "noArrestee":
                if (event.target.checked) {
                    setCheckboxFilter("hasArrestee", "N");
                } else {
                    setCheckboxFilter("hasArrestee", "Y");
                }
                break;
            case "juvenile":
                if (event.target.checked) {
                    setCheckboxFilter("juvenileOffender", "Y");
                } else {
                    setCheckboxFilter("juvenileOffender", "N");
                }
                break;
            case "adult":
                if (event.target.checked) {
                    setCheckboxFilter("juvenileOffender", "N");
                } else {
                    setCheckboxFilter("juvenileOffender", "Y");
                }
                break;
            case "showIncidents":
                if (event.target.checked) {
                    setCheckboxFilter("showIncidents", "Y");
                } else {
                    setCheckboxFilter("showIncidents", "N");
                }
                break;
            case "showCallsForService":
                if (event.target.checked) {
                    setCheckboxFilter("showCallsForService", "Y");
                } else {
                    setCheckboxFilter("showCallsForService", "N");
                }
                break;
        }
    };

    const setCheckboxFilter = (flagName, value) => {
        if (context.filters[flagName]) {
            // if flag is not null, set to null, represents both options selected or both options deselected
            setContext({...context, filters: {...context.filters, [flagName]: null}});
        } else {
            // if flag is null, set filter to given value
            setContext({...context, filters: {...context.filters, [flagName]: value}});
        }
    };

    useEffect(() => {
        axios.get(packageJson.homepage+'/api/v1/getCrimeTypes', {
            params: { schema: context.schema }
        }).then(res => {
            setCrimeTypes(res.data);
        });
    }, [context.schema])

    useEffect(() => {
        axios.get(packageJson.homepage+'/api/v1/getCallTypes', {
            params: { schema: context.schema }
        }).then(res => {
            setCallTypes(res.data);
        });
    }, [context.schema])


    return (
        <FilterPanel sidebarWidth={props.sidebarWidth} selected={props.selected} close={props.close}>
            <Container>
                <FormControl className={classes.formControl}>
                    <h3>Crime Type</h3>
                    <Select
                        multiple
                        displayEmpty
                        value={allSelected ? ["all"].concat(selectedCrimes) : selectedCrimes}
                        onChange={handleCrimeChange}
                        input={<Input/>}
                        renderValue={(selected) => {
                            if (selected.length === 0) {
                                return <InputLabel>Type</InputLabel>;
                            }
                            return <div style={{ whiteSpace: 'normal', lineHeight: '1.4' }}>{selected.join(', ')}</div>;
                        }}
                        style={{ height: 'auto' }}
                        MenuProps={MenuProps}
                    >
                        <MenuItem key={"all"} value={"all"}>
                            <Checkbox checked={allSelected} color="primary"/>
                            <ListItemText primary={"Select All"}/>
                        </MenuItem>
                        {crimeTypes.map((crimeType) => (
                            <MenuItem key={crimeType} value={crimeType}>
                                <Checkbox checked={selectedCrimes.indexOf(crimeType) > -1} color="primary"/>
                                <ListItemText primary={crimeType}/>
                            </MenuItem>
                        ))}
                    </Select>
                    <h3 style={{paddingTop: "1em"}}>Crime Details</h3>
                    <div className={classes.formRow}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={checkboxes.attempted}
                                    onChange={handleCheckboxChange}
                                    name="attempted"
                                    color="primary"
                                />
                            }
                            label="Attempted"
                            labelPlacement="end"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={checkboxes.completed}
                                    onChange={handleCheckboxChange}
                                    name="completed"
                                    color="primary"
                                />
                            }
                            label="Completed"
                            labelPlacement="end"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={checkboxes.hasArrestee}
                                    onChange={handleCheckboxChange}
                                    name="hasArrestee"
                                    color="primary"
                                />
                            }
                            label="Arrest"
                            labelPlacement="end"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={checkboxes.noArrestee}
                                    onChange={handleCheckboxChange}
                                    name="noArrestee"
                                    color="primary"
                                />
                            }
                            label="No Arrest"
                            labelPlacement="end"
                        />
                    </div>
                    {/*
                    <div className={classes.formRow}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={checkboxes.juvenile}
                                    onChange={handleCheckboxChange}
                                    name="juvenile"
                                    color="primary"
                                />
                            }
                            label="Juvenile Offender"
                            labelPlacement="end"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={checkboxes.adult}
                                    onChange={handleCheckboxChange}
                                    name="adult"
                                    color="primary"
                                />
                            }
                            label="Adult Offender"
                            labelPlacement="end"
                        />
                    </div>
                    */}
                    <h3 style={{paddingTop: "1em"}}>Call Types</h3>
                    <Select
                        multiple
                        displayEmpty
                        value={allCallTypesSelected ? ["all"].concat(selectedCallTypes) : selectedCallTypes}
                        onChange={handleCallTypeChange}
                        input={<Input/>}
                        renderValue={(selected) => {
                            if (selected.length === 0) {
                                return <InputLabel>Type</InputLabel>;
                            }
                            const MAX_CHARS = 100;
                            const joined = selected.join(', ');
                            const display = joined.length > MAX_CHARS
                                ? joined.slice(0, MAX_CHARS).trimEnd() + '...'
                                : joined;
                            return <div style={{ whiteSpace: 'normal', lineHeight: '1.4' }}>{display}</div>;
                        }}
                        style={{ height: 'auto' }}
                        MenuProps={MenuProps}
                    >
                        <MenuItem key={"all"} value={"all"}>
                            <Checkbox checked={allCallTypesSelected} color="primary"/>
                            <ListItemText primary={"Select All"}/>
                        </MenuItem>
                        {callTypes.map((callType) => (
                            <MenuItem key={callType} value={callType}>
                                <Checkbox checked={selectedCallTypes.indexOf(callType) > -1} color="primary"/>
                                <ListItemText primary={callType}/>
                            </MenuItem>
                        ))}
                    </Select>
                    <h3 style={{paddingTop: "1em"}}>Events</h3>
                    <div className={classes.formRow}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={checkboxes.showIncidents}
                                    onChange={handleCheckboxChange}
                                    name="showIncidents"
                                    color="primary"
                                />
                            }
                            label="Incidents"
                            labelPlacement="end"
                        />
                    </div>
                    <div className={classes.formRow}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={checkboxes.showCallsForService}
                                    onChange={handleCheckboxChange}
                                    name="showCallsForService"
                                    color="primary"
                                />
                            }
                            label="Calls"
                            labelPlacement="end"
                        />
                    </div>
                </FormControl>
            </Container>
        </FilterPanel>
    );
}

export default CrimeFilters;
